import { type ExtraValues, type PlatformEvent } from '../types';

export const adIsSkippedEvent = (extra: ExtraValues): PlatformEvent => {
  return {
    type: 'ad',
    created: Date.now(),
    user_properties: {
      ...(extra && { ...extra.user_properties }),
    },
    event_properties: {
      name: 'view_skipped',
      ...extra.event_properties,
    },
  };
};
